import { Reveal, Eyebrow } from "./Reveal";

const CREDENTIALS = ["MBBS", "DCH", "DNB Pediatrics"];

const About = () => (
  <section id="about" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative max-w-sm mx-auto lg:mx-0">
            <div className="absolute -top-5 -left-5 w-full h-full rounded-[26px] border border-[#B89A69]/40" aria-hidden="true" />
            <div className="relative rounded-[22px] overflow-hidden shadow-card">
              <img
                data-testid="about-portrait-image"
                src="/images/about-newborn.webp"
                alt="Dr. Ojaswini Sheshrao Gajbhiye in blue scrubs, gently holding a newborn baby"
                className="w-full aspect-[4/5] object-cover object-center"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-7 left-1/2 -translate-x-1/2 bg-white border border-[#E7DED4] rounded-full px-6 py-3 shadow-card whitespace-nowrap">
              <span className="font-display italic text-[#70435F] text-lg">Thoughtful pediatric care</span>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7 mt-10 lg:mt-0">
          <Reveal>
            <Eyebrow>About</Eyebrow>
            <h2
              data-testid="about-heading"
              className="font-display text-3xl sm:text-4xl lg:text-[42px] font-medium tracking-tight text-[#383237] leading-tight mt-5 mb-8"
            >
              A journey dedicated to <em className="italic text-[#70435F]">children's health</em>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div data-testid="about-narrative" className="space-y-5 text-base text-[#695E67] leading-relaxed">
              <p>
                Dr. Ojaswini Sheshrao Gajbhiye is a pediatrician with qualifications in MBBS, Diploma in
                Child Health (DCH), and Diplomate of National Board (DNB) in Pediatrics.
              </p>
              <p>
                Her professional training includes clinical experience at Grant Government Medical College
                and Sir JJ Group of Hospitals, Mumbai, and Nirmal Hospital, Surat.
              </p>
              <p>
                Her background encompasses Pediatrics, Neonatology, newborn care, pediatric intensive care,
                and management of infectious diseases in children.
              </p>
              <p>
                With an interest in preventive pediatrics and parenting education, she aims to make reliable
                child health information more accessible to families.
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.1} className="mt-16">
        <div
          data-testid="about-credentials-strip"
          className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 border-y border-[#E7DED4] py-6"
        >
          {CREDENTIALS.map((c, i) => (
            <span key={c} className="flex items-center gap-6">
              <span className="font-display text-xl sm:text-2xl font-semibold text-[#70435F] tracking-wide">{c}</span>
              {i < CREDENTIALS.length - 1 && (
                <span className="w-1.5 h-1.5 rotate-45 bg-[#B89A69]" aria-hidden="true" />
              )}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default About;
